// PostHog analytics integration for the Client Portal.

import posthog from "posthog-js";

let _initialized = false;

/** One-time PostHog init; the parsed ETCF `config` object supplies every option. */
export const initAnalytics = (token, config = {}) => {
    if (_initialized || !token) return;
    posthog.init(token, {
        api_host: "https://us.i.posthog.com", // Default host; overridden by config.api_host.
        ...config,
    });
    _initialized = true;
};

export const isAnalyticsReady = () => _initialized;

/** Captures a named analytics event. */
export const captureEvent = (eventName, properties = {}) =>
    _initialized && posthog.capture(eventName, properties);

// Tracks the last identified user to detect a user switch on this device.
const LAST_UID_KEY = "ph_last_uid";

/**
 * Associates the logged-in user with events and session recordings. Resets first if a different
 * user was identified on this device, so their data isn't merged into the new user.
 */
export const identifyUser = (userId, properties = {}) => {
    if (!_initialized || !userId) return;
    const uid = String(userId);
    const last = localStorage.getItem(LAST_UID_KEY);
    if (last && last !== uid) posthog.reset();
    posthog.identify(uid, properties);
    localStorage.setItem(LAST_UID_KEY, uid);
};

/** Clears identity on logout so the next user isn't merged into the previous one. */
export const resetUser = () => {
    if (!_initialized) return;
    posthog.reset();
    localStorage.removeItem(LAST_UID_KEY);
};
